import { asyncModalAdapter } from 'App/helpers/angularPortingHelpers';

export const openMultiUpdateClientModal = asyncModalAdapter({
	upModalName: 'UpdateClientMulti',
	openModalName: 'MultiUpdateClient',
	featureFlag: 'REACT_MULTI_UPDATE_CLIENT',
	rejectOnEvent: true
});
